import { render, staticRenderFns } from "./ViewPlotDetails1002.vue?vue&type=template&id=64606168"
import script from "./ViewPlotDetails1002.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails1002.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports